<script lang="ts" setup>
import {useUser} from "~/composables/useUser";
import {useForm} from 'vee-validate';
import * as yup from 'yup';
import {validatePassword} from "~/utils/util";

const {openModal} = useModal();
const {signUp} = useUser();
const emit = defineEmits(["onSubmitNewUser"])

const props = defineProps({
  openSignModal: {type: Boolean, default: true}
})

const schema = yup.object({
  name: yup.string().required('O nome é obrigatório'),
  email: yup.string().email()
      .typeError('Informe um e-mail válido')
      .required('E-mail é obrigatório'),
  password: yup
      .string()
      .required('Senha é obrigatória')
      .min(8, 'A senha deve ter pelo menos 8 caracteres')
      .matches(/^(?=.*[A-Za-z])(?=.*\d)/, 'A senha deve conter pelo menos uma letra e um número')
      .test('no-sequence', 'A senha não pode conter sequências simples (ex: 123 ou abc)', validatePassword),
  confirmPassword: yup
      .string()
      .required('A confirmação de senha é obrigatória')
      .oneOf([yup.ref('password'), null], 'As senhas não conferem'),

  accept: yup
      .boolean()
      .oneOf([true], 'Você deve aceitar os termos de uso para continuar')
      .required('Os termos de uso devem ser aceitos')

});
const {handleSubmit} = useForm({validationSchema: schema});

const formFields = reactive([
  {name: 'name', type: 'text', label: 'Nome Completo'},
  {name: 'email', type: 'email', label: 'E-mail'},
  {name: 'password', type: 'password', label: 'Senha'},
  {name: 'confirmPassword', type: 'password', label: 'Confirmar Senha'},
  {name: 'accept', type: 'checkbox', label: `Ao aderir, concordo com os<a href="/politicas/termos-de-uso">Termos de Uso</a> e <a href="/politicas/privacidade">Política de Privacidade</a>`}
])

const onSubmit = handleSubmit(async ({name, email, password}) => {
  const success = await signUp({
    name: name.trim(),
    email: email.trim().toLowerCase(),
    password: password.trim()
  });
  if (success) {
    if (props.openSignModal) openModal('sign-modal')
    emit("onSubmitNewUser")
  }
});

</script>
<template>
  <div class="row mx-0 align-items-center">
    <div class="col-md-12 px-4 pt-2 pb-4 px-sm-5 pb-sm-5 pt-md-5">
      <h2 class="h3 mb-4 mb-sm-5">Cadastre-se já!<br/>Tenha acesso total a plataforma</h2>
      <!-- <a class="btn btn-outline-info w-100 mb-3" href="javascript:void(0);">
        <i class="fi-google fs-lg me-1"></i>Cadastrar-se com Google
      </a>
      <a class="btn btn-outline-info w-100 mb-3" href="javascript:void(0);">
        <i class="fi-facebook fs-lg me-1"></i>Cadastre-se com Facebook
      </a>
      <div class="d-flex align-items-center py-3 mb-3">
        <hr class="w-100"/>
        <div class="px-3">Ou</div>
        <hr class="w-100"/>
      </div> -->
      <form @submit.prevent="onSubmit">
        <DynamicForm :fields="formFields"/>
        <div class="pt-4">
          <button type="submit" class="btn btn-primary px-5">Cadastrar</button>
        </div>
      </form>
      <div class="mt-sm-2 pt-md-3">
        Já possui uma conta?
        <a class="text-primary" style="cursor: pointer" @click="() => openModal('sign-modal')">Entrar</a>
      </div>
    </div>
  </div>
</template>
